<template>
        
			<div class="">
        	<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        		<template v-if="!list">
        			<noneData></noneData>
        		</template>
        		<template v-else>
        		<van-list v-model="loading" :finished="finished" finished-text="加载完毕" @load="onLoad">
        			<div v-for="(item,index) in list" :key="index" @click="download(item)" class="van-hairline--bottom marginBottomXm setWhite">
						<van-cell :title="item.title"  size="large"  is-link icon="todo-list" />
        			</div>
        		</van-list>
        		</template>
        	</van-pull-refresh>
			</div>
	
</template>

<script>
	export default {
		data() {
			return {
				list: [],
				joyPageStatus: '',
				loading: false,
				finished: false,
				isLoading: false,
				page:0,
			}
		},
		created(e) {
			this.onLoad();
		},
		activated() {
			this.isLoading=false;
		},
		methods: {
			download(item){
				window.open(item.src);
			},
			onRefresh() {
				setTimeout(() => {
					this.isLoading = false;
					this.reload();
					this.$toast('刷新成功');
				}, 500);
			},
			onLoad() {
				// 异步更新数据
				setTimeout(() => {
					this.loadData();
				}, 500);
			},
			reload() {
				this.list = [];
				this.loading = false;
				this.finished = false;
				this.page=0;
				this.onLoad();
			},
			loadData(){
				const that=this;
				this.joyPageStatus = 'loading';
				try{
					that.page++;
					that.$axios.get('/train/list?type=2&limits=10&page='+that.page).then(response => {
						if (response.data.code == 200) {
							that.joyPageStatus = 'success';
							let list=[];
							let data = response.data.data.video_list;
							for (let i = 0; i < data.length; i++) {
								data[i].poster="http://img.jiarixiaodui.com/"+data[i].poster;
								data[i].src="http://img.jiarixiaodui.com/"+data[i].src;
								list.push(data[i]);
							};
							that.list=that.list.concat(list);
							that.loading = false;
							if (data.length == 0) {
								that.finished = true;
							};
							}
						})
				}catch(e){
					if (this.$mConfig.debug) {
						console.log(e);
					};
				}
			},
		}
	}
</script>

<style scoped="scoped">
	.adPic{
	 /* max-height:53.33vw; */
	  overflow: hidden;
		
	  
	}
</style>
